var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 356,
    viewBox: "0 0 96 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6572 0.223145L26.3481 137.888L40.447 127.073V147.604L22.4876 163.735L18.1237 193.614L31.7191 183.166L16.2774 206.079L14.0954 221.294L31.7191 207.729C7.88516 242.008 12.2491 232.659 6.03887 275.004L22.9912 261.989V282.519L2.17845 301.034L0.5 312.399H95.3322L46.6572 0.223145Z",
    fill: "#016256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M46.4895 0.223145L46.8252 312.399H95.5001L46.4895 0.223145Z",
    fill: "#016256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6573 49.3501L40.447 355.293H63.106L46.6573 49.3501Z",
    fill: "#331C10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1873 163.735L49.8463 193.981V207.912L27.1873 163.735Z",
    fill: "#331C10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0476 222.394L47.3285 244.208V254.29L31.0476 222.394Z",
    fill: "#331C10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5513 274.271L48 295.901V305.984L31.5513 274.271Z",
    fill: "#331C10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6697 233.759L47.3287 264.005V277.937L24.6697 233.759Z",
    fill: "#331C10"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1201 149.804L48.3357 177.85V191.782L65.1201 149.804Z",
    fill: "#331C10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1343 177.85L50.3499 205.896V219.827L67.1343 177.85Z",
    fill: "#331C10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4771 280.136L51.6926 307.999V322.114L68.4771 280.136Z",
    fill: "#331C10"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6732 202.597L50.3499 238.525V256.49L72.6732 202.597Z",
    fill: "#331C10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3587 232.659L51.3569 272.987V292.968L75.3587 232.659Z",
    fill: "#331C10"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7544 106.542L48 121.574V128.54L36.7544 106.542Z",
    fill: "#331C10"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4205 131.289L47.3286 152.92V163.918L60.4205 131.289Z",
    fill: "#331C10"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7279 92.4277L46.6572 109.109V117.541L56.7279 92.4277Z",
    fill: "#331C10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.9169 294.434L58.7419 274.27L75.3585 232.659L58.0706 261.622L56.8956 240.541L72.673 202.596L56.3921 228.81L55.2172 207.729L67.1342 177.85L54.7137 198.564L53.7066 178.583L65.12 149.803L53.2031 169.784L52.196 151.82L60.4204 131.289L51.8603 145.587L49.8462 109.475L56.7278 92.4276L49.6783 104.159L48.8391 89.4946V355.293H63.1059L60.2525 300.667L68.4769 280.136L59.9169 294.434Z",
    fill: "#331C10"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeImg);
export default __webpack_public_path__ + "static/media/tree_img.509a9c748dff311c93019dc415c7dcb4.svg";
export { ForwardRef as ReactComponent };